export default function Footer() {
  return (
    <footer className="sticky w-full mt-auto">
      <div className="text-center p-6 bg-white text-blue-700">
        <small>© 2022 Copyright: Fakultas Ilmu Komputer Universitas Indonesia</small>
      </div>
    </footer>
  );
}
